/**
 * @name ReadMessageTemplateController
 * @description Controller for displaying message templates
 * @param {library} $uibModalInstance The uib Modal Instance
 * @param {resolve} messageTemplate The resolved message template
 * @param {resolve} messageTitle The resolved message template title
 */
function ReadMessageTemplateController(
  $uibModalInstance,
  messageTemplate,
  messageTitle
) {
  let vm = this;
  vm.messageTemplate = messageTemplate;
  vm.messageTitle = messageTitle;

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('ReadMessageTemplateController', ReadMessageTemplateController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/read-message-templates/read-message-templates.controller.js